import React from "react";
import { Grid } from "@mui/material";
import { images } from "../../config/images";
import "./SliderAuth.css"
import translations from "../../config/language";

const SliderAuth = () => {

    const language = process.env.REACT_APP_LANGUAGE;

    const currentYear = new Date().getFullYear();

    return (
        <>
            <Grid item xs={12} md={7} lg={8} className="slider-wrapper">
                <div className="slider-container">
                    <img src={images.sliderBackground} alt="slider-background" className="background-image" />
                    <div className="slider-content">
                        <img src={images.logo} alt="logo" className="slider-logo" />
                        <h1>{translations[language].welcome}</h1>

                        <p
                        className="description"
                        dangerouslySetInnerHTML={{ __html: translations[language].welcomeDescription }}
                    />
                        
                    </div>
                    <div className="slider-copyright">
                        <p>©{currentYear} {translations[language].niccrra} {translations[language].allCopyRightReserved}</p>
                    </div>
                </div>
            </Grid>
        </>
    )
}

export default SliderAuth;